export default __webpack_public_path__ + "static/media/Baby52.231e457e.gif";